<div class="row">
  <div class="col-12">
    <div class="card card-body">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="card-title mb-0">
          <span class="lstick"></span>Vending Products
        </h4>
        <div class="d-flex align-items-center">
          <div class="search-container">
            <input type="text" class="form-control" placeholder="Search products..." [(ngModel)]="searchQuery"
              (input)="onSearchChange()" />
          </div>
          <div class="mr-2">
            <button type="button" class="btn btn-outline-primary" (click)="downloadSampleCSV()"
              ngbTooltip="Download sample CSV format" placement="top">
              <i class="fa fa-download"></i> Sample CSV
            </button>
          </div>
          <div class="mr-2">
            <label for="csvUpload" class="btn btn-primary mb-0">
              <i class="fa fa-upload"></i> Upload CSV
            </label>
            <input type="file" id="csvUpload" accept=".csv" style="display: none"
              (change)="uploadProductsFromCSV($event)" />
          </div>
          <a href="javascript: void(0);" class="btn btn-primary mr-2" placement="top"
            (click)="openModal(editModal, {}, 'Add Product')" ngbTooltip="Add Product">
            + Add Product
          </a>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-striped border mt-4">
          <thead>
            <tr>
              <th scope="col">EAN Number</th>
              <th scope="col">Barcode Image</th>
              <th scope="col">Product Image</th>
              <th scope="col">Name</th>
              <th scope="col">Description</th>
              <th scope="col">Categories</th>
              <th scope="col">Weight</th>
              <th scope="col">Price</th>
              <th scope="col">Allow Shipment</th>
              <th scope="col">VAT (%)</th>
              <th scope="col">VAT Type</th>
              <th scope="col">Quantity</th>
              <th scope="col">Sold Quantity</th>
              <th scope="col">Featured</th>
              <th scope="col">Visible</th>
              <th scope="col">Campaign</th>
              <th scope="col">Festive Box</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let d of data; trackBy: trackById">
              <td (click)="openModal(editModal, d, 'Edit Product')" style="cursor: pointer">
                {{ d.EANNumber ? d.EANNumber : "-" }}
              </td>
              <td>
                <img *ngIf="d.barcodeImage" [src]="d.barcodeImage" alt="Product Image" style="
                    width: 50px;
                    height: 50px;
                    object-fit: cover;
                    cursor: pointer;
                  " (click)="openImageModal(ImageModal, d.barcodeImage, true)" />
                <span *ngIf="!d.barcodeImage" class="text-muted">No Image</span>
              </td>
              <td>
                <img *ngIf="d.productImage" [src]="d.productImage" (click)="openImageModal(ImageModal, d.productImage)"
                  alt="Product Image" style="
                    width: 50px;
                    height: 50px;
                    object-fit: cover;
                    cursor: pointer;
                  " />
                <span *ngIf="!d.productImage" class="text-muted">No Image</span>
              </td>
              <td>{{ d.name }}</td>
              <td>{{ d.description || "-" }}</td>
              <td>
                <span *ngFor="let c of d.categories">
                  <badge class="category-tag">{{ c.category_name }}</badge>
                </span>
              </td>
              <td>{{ d.weight || "-" }}</td>
              <td>{{ currency }} {{ d.price | number: "1.2-2" }}</td>
              <td>
                <span *ngFor="let c of d.allowedShipments">
                  <badge class="category-tag">{{ c }}</badge>
                </span>
              </td>

              <td>{{ d.vat || "0" }}</td>
              <td>
                <span class="badge px-3 rounded-pill" style="font-size: 100%"
                  [ngClass]="d.isExclusive ? 'badge-warning' : 'badge-success'">
                  {{ d.isExclusive ? "Exclusive" : "Inclusive" }}
                </span>
              </td>
              <td>{{ d.stockQuantity }}</td>
              <td>{{ d.totalSold == "0" ? "-" : d.totalSold }}</td>
              <td class="switch">
                <div class="readonly-switch-container">
                  <ui-switch [(ngModel)]="d.isFeatured" name="isFeatured" (ngModelChange)="toggleProductFeatured(d)">
                  </ui-switch>
                </div>
              </td>
              <td class="switch">
                <div class="readonly-switch-container">
                  <ui-switch [(ngModel)]="d.visible" name="visible"
                    (ngModelChange)="toggleProductVisibility(d)"></ui-switch>
                </div>
              </td>
              <td class="switch">
                <div class="readonly-switch-container">
                  <ui-switch [(ngModel)]="d.isCampaign" name="isCampaign" (ngModelChange)="toggleProductCampaign(d)">
                  </ui-switch>
                </div>
              </td>
              <td class="switch">
                <div class="readonly-switch-container">
                  <ui-switch [(ngModel)]="d.isFestiveBox" name="isFestiveBox" (ngModelChange)="toggleFestiveBox(d)">
                  </ui-switch>
                </div>
              </td>

              <td>
                <a href="javascript: void(0);" class="link mr-2" placement="top"
                  (click)="openModal(viewModal, d, 'View Product')" ngbTooltip="View details">
                  <i class="fa fa-eye"></i>
                </a>
                <a href="javascript: void(0);" class="link mr-2" placement="top"
                  (click)="openModal(editModal, d, 'Edit Product')" ngbTooltip="Edit">
                  <i class="fa fa-edit"></i>
                </a>

                <a href="javascript: void(0);" class="link mr-2" placement="top"
                  (click)="openModal(deleteModal, d, 'Delete Product')" ngbTooltip="Delete">
                  <i class="fa fa-trash"></i>
                </a>
              </td>
            </tr>
            <tr *ngIf="data?.length == 0">
              <td colspan="13" class="text-center">No products found</td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-between align-items-center mt-5" *ngIf="data?.length != 0">
          <div class="d-flex justify-content-between align-items-center mt-3">
            <div class="d-flex align-items-center">
              <label class="mr-2 mb-0">Show</label>
              <select class="form-control form-control-sm w-auto" [(ngModel)]="pageSize" (change)="onPageSizeChange()">
                <option *ngFor="let size of pageSizeOptions" [value]="size">
                  {{ size }}
                </option>
              </select>
              <label class="ml-2 mb-0">entries</label>
            </div>
          </div>

          <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="totalcount" [maxSize]="7"
            [rotate]="true" [ellipses]="false" [boundaryLinks]="true" (pageChange)="loadPage($event)"></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #editModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="editProductLabel">{{ modeltitle }}</h5>
    <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" style="max-height: 70vh; overflow-y: auto">
    <form (ngSubmit)="onSubmit(productform)" #productform="ngForm">
      <div class="form-group row">
        <label for="name" class="col-sm-4 col-form-label">Product Name *</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" [class.is-invalid]="name.invalid && name.touched" name="name"
            [(ngModel)]="detail.name" id="name" #name="ngModel" required placeholder="Enter product name" />
          <div class="invalid-feedback" *ngIf="name.invalid && name.touched">
            <div *ngIf="name.errors && name.errors?.required">
              Product name is required
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label for="description" class="col-sm-4 col-form-label">Description *</label>
        <div class="col-sm-8">
          <textarea class="form-control" [class.is-invalid]="description.invalid && description.touched"
            name="description" [(ngModel)]="detail.description" id="description" #description="ngModel" required
            rows="3" placeholder="Enter product description"></textarea>
          <div class="invalid-feedback" *ngIf="description.invalid && description.touched">
            <div *ngIf="description.errors && description.errors?.required">
              Description is required
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="productImage" class="col-sm-4 col-form-label">Product Image *</label>
        <div class="col-sm-8">
          <input type="file" class="form-control-file" [class.is-invalid]="productImageRequired && !detail.productImage"
            name="productImage" id="productImage" accept="image/*" (change)="onImageChange($event)" />
          <div class="invalid-feedback" *ngIf="productImageRequired && !detail.productImage">
            Product image is required
          </div>

          <div *ngIf="detail.productImage" class="mt-2">
            <img [src]="detail.productImage" alt="Preview" style="width: 100px; height: 100px; object-fit: cover" />
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="EANNumber" class="col-sm-4 col-form-label">EAN Number *</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" [class.is-invalid]="EANNumber.invalid && EANNumber.touched"
            name="EANNumber" [(ngModel)]="detail.EANNumber" id="EANNumber" #EANNumber="ngModel" required
            placeholder="Enter EAN Number" />
          <div class="invalid-feedback" *ngIf="EANNumber.invalid && EANNumber.touched">
            <div *ngIf="EANNumber.errors && EANNumber.errors?.required">
              EAN Number is required
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label for="stockQuantity" class="col-sm-4 col-form-label">Stock Quantity *</label>
        <div class="col-sm-8">
          <input type="number" class="form-control" [class.is-invalid]="stockQuantity.invalid && stockQuantity.touched"
            name="stockQuantity" [(ngModel)]="detail.stockQuantity" id="stockQuantity" #stockQuantity="ngModel" required
            min="0" placeholder="Enter stock quantity" />
          <div class="invalid-feedback" *ngIf="stockQuantity.invalid && stockQuantity.touched">
            <div *ngIf="stockQuantity.errors && stockQuantity.errors?.required">
              Stock Quantity is required
            </div>
            <div *ngIf="stockQuantity.errors && stockQuantity.errors?.min">
              Stock Quantity must be positive
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row" *ngIf="modeltitle === 'Edit Product'">
        <label for="totalSold" class="col-sm-4 col-form-label">Sold Quantity</label>
        <div class="col-sm-8">
          <input type="number" class="form-control" name="totalSold" [(ngModel)]="detail.totalSold" id="totalSold"
            min="0" placeholder="Enter sold quantity" />
        </div>
      </div>

      <div class="form-group row">
        <label for="weight" class="col-sm-4 col-form-label">Weight</label>
        <div class="col-sm-8">
          <input type="number" class="form-control" name="weight" [(ngModel)]="detail.weight" id="weight" min="0"
            step="0.01" placeholder="Enter weight in grams" />
          <small class="form-text text-muted">Weight pass in gram</small>
        </div>
      </div>

      <div class="form-group row">
        <label for="category" class="col-sm-4 col-form-label">Categories *</label>
        <div class="col-sm-8">
          <ng-multiselect-dropdown [placeholder]="'Select categories'" [settings]="dropdownSettings"
            [data]="dropdownList" [(ngModel)]="selectedItems" [ngModelOptions]="{ standalone: true }"
            (onSelect)="onItemSelect($event)" (onDeSelect)="onItemDeSelect($event)" required
            #categorySelect="ngModel"></ng-multiselect-dropdown>
          <div *ngIf="categorySelect.invalid && categorySelect.touched" class="text-danger">
            At least one category is required
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label for="barcodeImage" class="col-sm-4 col-form-label">Barcode Image</label>
        <div class="col-sm-8">
          <input type="file" class="form-control-file" name="barcodeImage" id="barcodeImage" accept="image/*"
            (change)="onBarcodeImageChange($event)" />
          <div *ngIf="detail.barcodeImage" class="mt-2">
            <img [src]="detail.barcodeImage" alt="Barcode Preview"
              style="width: 100px; height: 100px; object-fit: cover" />
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="price" class="col-sm-4 col-form-label">
          Price ({{ currency }}) *
        </label>
        <div class="col-sm-8">
          <input type="number" class="form-control" [class.is-invalid]="price.invalid && price.touched" name="price"
            [(ngModel)]="detail.price" id="price" #price="ngModel" step="0.01" min="0.01" required
            placeholder="Enter price" />
          <div class="invalid-feedback" *ngIf="price.invalid && price.touched">
            <div *ngIf="price.errors && price.errors?.required">
              Price is required
            </div>
            <div *ngIf="price.errors && price.errors?.min">
              Price must be greater than 0
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label for="oldPrice" class="col-sm-4 col-form-label">
          Old Price ({{ currency }}) *
        </label>
        <div class="col-sm-8">
          <input type="number" class="form-control" [class.is-invalid]="oldPrice.invalid && oldPrice.touched"
            name="oldPrice" [(ngModel)]="detail.oldPrice" id="oldPrice" #oldPrice="ngModel" min="0" required
            placeholder="Enter old price" />
          <div class="invalid-feedback" *ngIf="oldPrice.invalid && oldPrice.touched">
            <div *ngIf="oldPrice.errors && oldPrice.errors?.required">
              Old Price is required
            </div>
            <div *ngIf="oldPrice.errors && oldPrice.errors?.min">
              Old Price must be greater than or equal to 0
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label for="vat" class="col-sm-4 col-form-label"> VAT(%) * </label>
        <div class="col-sm-8">
          <input type="number" class="form-control" [class.is-invalid]="vat.invalid && vat.touched" name="vat"
            [(ngModel)]="detail.vat" id="vat" #vat="ngModel" step="0.01" min="0" max="100" required
            placeholder="Enter VAT percentage" />
          <div class="invalid-feedback" *ngIf="vat.invalid && vat.touched">
            <div *ngIf="vat.errors && vat.errors?.required">
              VAT is required
            </div>
            <div *ngIf="vat.errors && vat.errors?.min">
              VAT cannot be negative
            </div>
            <div *ngIf="vat.errors && vat.errors?.max">
              VAT cannot exceed 100%
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-4 col-form-label"> VAT Type </label>
        <div class="col-sm-8">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" [(ngModel)]="detail.isExclusive" name="isExclusive"
              id="vatExclusive" [value]="true" />
            <label class="form-check-label" for="vatExclusive">Exclusive</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" [(ngModel)]="detail.isExclusive" name="isExclusive"
              id="vatInclusive" [value]="false" />
            <label class="form-check-label" for="vatInclusive">Inclusive</label>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4 col-form-label">Featured Product</label>
        <div class="col-sm-8">
          <ui-switch [(ngModel)]="detail.isFeatured" [ngModelOptions]="{ standalone: true }"
            name="isFeatured"></ui-switch>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-4 col-form-label">Visible to Customers</label>
        <div class="col-sm-8">
          <ui-switch [(ngModel)]="detail.visible" [ngModelOptions]="{ standalone: true }" name="visible"></ui-switch>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-4 col-form-label">Campaign</label>
        <div class="col-sm-8">
          <ui-switch [(ngModel)]="detail.isCampaign" [ngModelOptions]="{ standalone: true }"
            name="isCampaign"></ui-switch>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-4 col-form-label">Festive Box</label>
        <div class="col-sm-8">
          <ui-switch [(ngModel)]="detail.isFestiveBox" [ngModelOptions]="{ standalone: true }"
            name="isFestiveBox"></ui-switch>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-4 col-form-label">Allow Shipment *</label>
        <div class="col-sm-8">
          <ng-multiselect-dropdown [placeholder]="'Select Shipment Options'" [settings]="shipmentDropdownSettings"
            [data]="shipmentDropdownList" [(ngModel)]="selectedShipments" [ngModelOptions]="{ standalone: true }"
            (onSelect)="onShipmentSelect()" (onDeSelect)="onShipmentDeSelect()"
            (onSelectAll)="onShipmentSelectAll($event)" (onDeSelectAll)="onShipmentDeSelectAll()" required>
          </ng-multiselect-dropdown>

          <div *ngIf="selectedShipments.length === 0" class="text-danger">
            At least one shipment option is required
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeBtnClick()">
      Close
    </button>
    <button type="submit" class="btn btn-primary" (click)="onSubmit(productform)">
      {{ modeltitle === "Add Product" ? "Add Product" : "Update Product" }}
    </button>
  </div>
</ng-template>

<div class="modal fade" [class.show]="showMapModal" [style.display]="showMapModal ? 'block' : 'none'"
  [style.z-index]="2000" tabindex="-1" role="dialog" *ngIf="showMapModal">
  <div class="modal-backdrop fade show" style="z-index: 1999"></div>
  <div class="modal-dialog modal-lg" role="document" style="z-index: 2001">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Select Product Location</h5>
        <button type="button" class="close" (click)="closeMapModal()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <p class="text-muted">
            <i class="fa fa-info-circle"></i>
            Click on the map to select a location, drag the marker to adjust, or
            use the search box to find a specific address.
          </p>
        </div>
        <div id="map" style="height: 400px; width: 100%"></div>
        <div class="mt-3" *ngIf="selectedLatitude && selectedLongitude">
          <div class="row">
            <div class="col-6">
              <strong>Latitude:</strong>
              {{ selectedLatitude | number: "1.6-6" }}
            </div>
            <div class="col-6">
              <strong>Longitude:</strong>
              {{ selectedLongitude | number: "1.6-6" }}
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeMapModal()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="confirmLocation()"
          [disabled]="!selectedLatitude || !selectedLongitude">
          Confirm Location
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #deleteModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ modeltitle }}</h5>
    <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <p>Are you sure you want to delete this product?</p>
    <div class="alert alert-warning">
      <strong>{{ detail.name }}</strong> will be permanently removed.
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeBtnClick()">
      Cancel
    </button>
    <button type="button" class="btn btn-danger" (click)="delete()">
      Delete Product
    </button>
  </div>
</ng-template>

<ng-template #ImageModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Image Preview</h5>
    <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body text-center">
    <img [src]="imageModal.image" alt="" width="100%" height="100%"
      [ngStyle]="imageModal?.isBarcode ? { 'max-width': '300px' } : {}" />
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeBtnClick()">
      Cancel
    </button>
  </div>
</ng-template>

<ng-template #viewModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="editProductLabel">{{ modeltitle }}</h5>
    <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" style="max-height: 70vh; overflow-y: auto">
    <div class="form-group row">
      <label class="col-sm-3 font-weight-bold">Product Name</label>
      <div class="col-sm-3">
        <p class="form-control-plaintext">{{ detail.name }}</p>
      </div>
      <label class="col-sm-3 font-weight-bold">Description</label>
      <div class="col-sm-3">
        <p class="form-control-plaintext">{{ detail.description }}</p>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-3 font-weight-bold">Price ({{ currency }})</label>
      <div class="col-sm-3">
        <p class="form-control-plaintext">{{ currency }} {{ detail.price }}</p>
      </div>
      <label class="col-sm-3 font-weight-bold">Old Price ({{ currency }})</label>
      <div class="col-sm-3">
        <p class="form-control-plaintext">
          {{ detail.oldPrice ? currency + " " + detail.oldPrice : "-" }}
        </p>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-3 font-weight-bold">VAT (%)</label>
      <div class="col-sm-3">
        <p class="form-control-plaintext">
          {{ detail.vat ? detail.vat + "%" : "0%" }}
        </p>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-3 font-weight-bold">VAT Type</label>
      <div class="col-sm-3">
        <p class="form-control-plaintext">
          {{ detail.isExclusive ? "Exclusive" : "Inclusive" }}
        </p>
      </div>

      <label class="col-sm-3 font-weight-bold">Featured</label>
      <div class="col-sm-3 d-flex align-items-center">
        <ui-switch [checked]="detail.isFeatured" class="no-event"></ui-switch>
      </div>
      <label class="col-sm-3 font-weight-bold">Visible</label>
      <div class="col-sm-3 d-flex align-items-center">
        <ui-switch [checked]="detail.visible" class="no-event"></ui-switch>
      </div>

      <label class="col-sm-3 font-weight-bold">Campaign</label>
      <div class="col-sm-3 d-flex align-items-center">
        <ui-switch [checked]="detail.isCampaign" class="no-event"></ui-switch>
      </div>
      <label class="col-sm-3 font-weight-bold">Festive Box</label>
      <div class="col-sm-3 d-flex align-items-center">
        <ui-switch [checked]="detail.isFestiveBox" class="no-event"></ui-switch>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-3 font-weight-bold">Quantity</label>
      <div class="col-sm-3">
        <p class="form-control-plaintext">
          {{ detail.stockQuantity }}
        </p>
      </div>
      <label class="col-sm-3 font-weight-bold">Sold Quantity</label>
      <div class="col-sm-3">
        <p class="form-control-plaintext">
          {{ detail.totalSold == 0 ? "-" : detail.totalSold }}
        </p>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-3 font-weight-bold">Weight</label>
      <div class="col-sm-3">
        <p class="form-control-plaintext">
          {{ detail.weight || "-" }}
        </p>
      </div>
      <label class="col-sm-3 font-weight-bold">Product category</label>
      <ng-container *ngFor="let category of detail.categoryIds">
        <span class="category-tag" style="font-size: 13px">
          {{ category.category_name }}
        </span>
      </ng-container>
    </div>
    <div class="form-group row">
      <label class="col-sm-3 font-weight-bold">Allow Shipment</label>
      <ng-container *ngFor="let shipment of detail.allowedShipments">
        <span class="category-tag" style="font-size: 13px">
          {{ shipment }}
        </span>
      </ng-container>
    </div>

    <div class="form-group row">
      <label class="col-sm-3 font-weight-bold">EAN Number</label>
      <div class="col-sm-3">
        <p class="form-control-plaintext">
          {{ detail.EANNumber }}
        </p>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-3 font-weight-bold">Product category</label>
      <ng-container *ngFor="let category of detail.categoryIds">
        <span class="category-tag" style="font-size: 13px">
          {{ category.category_name }}
        </span>
      </ng-container>
    </div>

    <div class="form-group row">
      <label class="col-sm-3 font-weight-bold">Product Image</label>
      <div class="col-sm-3">
        <ng-container *ngIf="detail.productImage; else noProductImage">
          <img [src]="detail.productImage" class="img-thumbnail" alt="Product" style="
              width: 100%;
              max-width: 150px;
              object-fit: contain;
              min-height: 150px;
            " />
        </ng-container>
        <ng-template #noProductImage>
          <p class="text-muted">No Image</p>
        </ng-template>
      </div>

      <label class="col-sm-3 font-weight-bold">Barcode Image</label>
      <div class="col-sm-3">
        <ng-container *ngIf="detail.barcodeImage; else noBarcodeImage">
          <img [src]="detail.barcodeImage" class="img-thumbnail" alt="Barcode" style="width: 100%; max-width: 150px" />
        </ng-container>
        <ng-template #noBarcodeImage>
          <p class="text-muted">No Image</p>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeBtnClick()">
      Close
    </button>
  </div>
</ng-template>